import React from 'react';
import { Typography, Grid } from '@mui/material';

export default class UpdateThanksPage extends React.Component {
  render() {
    const { promotion } = this.props;

    return (
      <React.Fragment>
        <Typography variant="h4" gutterBottom align="center">
          Thanks!
        </Typography>

        <Typography variant="h5" paragraph align="center">
          Your {promotion.competition ? 'entry' : 'claim'} details have been updated successfully
        </Typography>

        <Grid container spacing={2} justify="center">
          <Typography className="block" variant="body2" paragraph align="center">
             A notification will be sent to you via the email address you provided once fulfilment has been retried with these updated details.
          </Typography>
          <Typography className="block" variant="body2" paragraph align="center">
            Thank you.
          </Typography>
        </Grid>
      </React.Fragment>
    )
  }
}
